import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuetify from "vuetify";
import store from "./store";
import LoadingApp from "@/components/LoadingApp.vue";

Vue.use(Vuetify);
Vue.component("LoadingApp", LoadingApp);

new Vue({
  render: (h) => h(App),
  router,
  vuetify: new Vuetify(),
  store,
}).$mount("#app");

// console.log("API URL:", process.env.VUE_APP_API_URL);
// console.log("App Name:", process.env.VUE_APP_APP_NAME);
